import { create } from 'zustand'

const THEME_STORAGE_KEY = 'bitassay-theme'
type ThemeMode = 'dark' | 'light'

function applyTheme(mode: ThemeMode) {
  if (typeof document === 'undefined') return
  document.documentElement.classList.toggle('dark', mode === 'dark')
}

function detectSystemTheme(): ThemeMode {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return 'dark'
  }
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

function getInitialTheme(): ThemeMode {
  if (typeof window === 'undefined') return 'dark'

  const stored = window.localStorage.getItem(THEME_STORAGE_KEY)
  if (stored === 'dark' || stored === 'light') return stored

  const detected = detectSystemTheme()
  // Persist first-visit auto-detected preference so future visits remain fixed.
  window.localStorage.setItem(THEME_STORAGE_KEY, detected)
  return detected
}

export function initializeTheme() {
  const mode = getInitialTheme()
  applyTheme(mode)
  return mode
}

interface ThemeState {
  isDark: boolean
  toggle: () => void
}

const initialMode = initializeTheme()

export const useThemeStore = create<ThemeState>((set) => ({
  isDark: initialMode === 'dark',
  toggle: () =>
    set((state) => {
      const nextMode: ThemeMode = state.isDark ? 'light' : 'dark'
      applyTheme(nextMode)
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(THEME_STORAGE_KEY, nextMode)
      }
      return { isDark: nextMode === 'dark' }
    }),
}))
